var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-chart"},[_c('div',{ref:"container",staticClass:"chart-dom-container"},[_c('div',{ref:"chart",staticClass:"chart-dom"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }